export default __webpack_public_path__ + "static/media/logo2.33d8db30.png";